import { cn } from '@optools/components/ui/utils';
import * as React from 'react';

export const ScrollPage = ({
  children,
  className,
  ...props
}: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>) => (
  <div className={cn('h-full overflow-auto', className)} {...props}>
    {children}
  </div>
);
